import ChildMood from '../dto/ChildMood';
import Error from '../model/Error';
import axios from 'axios';

export default class ChildMoodRepository {
    static findForChildAndMonth(childId, month, year) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/children/${childId}/moods/${year}/${month}`)
                .then((response) => resolve(response.data.data.map((data) => ChildMood.fromData(data))))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static update(childId, mood) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/children/${childId}/moods/${(mood.date.format('Y/M/D'))}`, mood.toData())
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static updateAllowedParents(childId, parentIds) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/children/${childId}/mood-parent-settings`, { allowed_parent_user_ids: parentIds })
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
